/** Converte dd/MM/yyyy para YYYY-MM-DD (MySQL). */
export function parseDDMMYYYYToMySQL(str) {
  if (!str || typeof str !== "string") return str;
  const t = str.trim();
  const m = t.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (!m) return t;
  const [, d, mo, y] = m;
  const dia = d.padStart(2, "0");
  const mes = mo.padStart(2, "0");
  return `${y}-${mes}-${dia}`;
}

/** Retorna a data seguinte (data + 1 dia) no formato dd/mm/yyyy. Aceita YYYY-MM-DD ou dd/mm/yyyy. */
export function dataMaisUmDia(dateStr) {
  if (!dateStr || typeof dateStr !== "string") return "";
  const t = dateStr.trim();
  let year, month, day;
  const isoMatch = t.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (isoMatch) {
    year = parseInt(isoMatch[1], 10);
    month = parseInt(isoMatch[2], 10);
    day = parseInt(isoMatch[3], 10);
  } else {
    const brMatch = t.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    if (!brMatch) return "";
    day = parseInt(brMatch[1], 10);
    month = parseInt(brMatch[2], 10);
    year = parseInt(brMatch[3], 10);
  }
  const d = new Date(year, month - 1, day);
  if (isNaN(d.getTime())) return "";
  d.setDate(d.getDate() + 1);
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
}

/** Converte string (YYYY-MM-DD ou dd/mm/yyyy) em Date. Retorna null se inválido. */
export function parseToDate(dateStr) {
  if (!dateStr || typeof dateStr !== "string") return null;
  const t = dateStr.trim();
  let year, month, day;
  const isoMatch = t.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (isoMatch) {
    year = parseInt(isoMatch[1], 10);
    month = parseInt(isoMatch[2], 10);
    day = parseInt(isoMatch[3], 10);
  } else {
    const brMatch = t.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    if (!brMatch) return null;
    day = parseInt(brMatch[1], 10);
    month = parseInt(brMatch[2], 10);
    year = parseInt(brMatch[3], 10);
  }
  const d = new Date(year, month - 1, day);
  return isNaN(d.getTime()) ? null : d;
}

/** Retorna a diferença em dias (dataFim - dataInicio). Aceita YYYY-MM-DD ou dd/mm/yyyy. */
export function diferencaEmDias(dataInicio, dataFim) {
  const d1 = parseToDate(dataInicio);
  const d2 = parseToDate(dataFim);
  if (!d1 || !d2) return null;
  const ms = d2.getTime() - d1.getTime();
  return Math.round(ms / (1000 * 60 * 60 * 24));
}

/** Normaliza valor de data do backend para YYYY-MM-DD (uso em inputs). */
export function normalizarDataParaInput(val) {
  if (val == null || val === "") return "";
  if (val instanceof Date) return !isNaN(val.getTime()) ? val.toISOString().slice(0, 10) : "";
  const s = String(val).trim();
  if (!s) return "";
  const isoMatch = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (isoMatch) return isoMatch[0];
  const brMatch = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (brMatch) return parseDDMMYYYYToMySQL(s);
  const parsed = parseToDate(s);
  if (!parsed) return "";
  const yyyy = parsed.getFullYear();
  const mm = String(parsed.getMonth() + 1).padStart(2, "0");
  const dd = String(parsed.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}

/** Soma N dias à data e retorna no formato YYYY-MM-DD. Aceita YYYY-MM-DD ou dd/mm/yyyy. */
export function adicionarDias(dateStr, dias) {
  const d = parseToDate(dateStr);
  if (!d || typeof dias !== "number") return "";
  d.setDate(d.getDate() + dias);
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}
